import { FileText, ShieldCheck, Detective, Cloud, Megaphone, ChartLineUp, GraduationCap, Scales, Gavel, MicrophoneStage } from "@phosphor-icons/react";

/**
 * Single source of truth for the 10 AI Specialists. Used by the AI Studio gallery and
 * the Client Workspace assistant launcher. `key` matches the ?assistant= param and
 * the legacy route; `perm` gates visibility (same as the sidebar).
 */
export const ASSISTANTS = [
  { key: "proposals", label: "Proposal Assistant", route: "/proposals", perm: "proposal:view", icon: FileText,
    useCase: "Proposals, RFP shred, capture & win strategy, orals, pricing, color review" },
  { key: "grc", label: "GRC Assistant", route: "/grc", perm: "grc:view", icon: ShieldCheck,
    useCase: "Compliance mapping, risk, SoA, crosswalks, audit readiness, BCP/DR" },
  { key: "soc", label: "SOC / MDR Assistant", route: "/soc", perm: "soc:view", icon: Detective,
    useCase: "IR, triage, threat hunting, detection engineering, intel, vuln triage" },
  { key: "cloud", label: "Cloud Assistant", route: "/cloud", perm: "cloud:view", icon: Cloud,
    useCase: "Posture, hardening, IaC review, IAM, K8s, migration, FinOps, DR" },
  { key: "sales", label: "Sales Assistant", route: "/sales", perm: "sales:view", icon: Megaphone,
    useCase: "Targeting, outreach, battle cards, case studies, campaigns, messaging" },
  { key: "executive", label: "Executive Assistant", route: "/executive", perm: "executive:view", icon: ChartLineUp,
    useCase: "Board briefs, QBRs, memos, talking points, OKRs, investor updates" },
  { key: "training", label: "Training Assistant", route: "/training", perm: "training:view", icon: GraduationCap,
    useCase: "Awareness, role-based, onboarding, phishing, quizzes, campaigns" },
  { key: "governance", label: "AI Governance Assistant", route: "/governance", perm: "aigov:view", icon: Scales,
    useCase: "AI risk, model cards, impact assessments, inventory, vendor reviews" },
  { key: "legal", label: "Legal Assistant", route: "/legal", perm: "legal:view", icon: Gavel,
    useCase: "Review, drafting, comparison, summaries, negotiation playbooks, DPAs" },
  { key: "meetings", label: "Meeting Copilot", route: "/meetings", perm: "dashboard:view", icon: MicrophoneStage,
    useCase: "Record, upload or paste a meeting → summary, decisions, action items → client tasks" },
];

export const ASSISTANT_BY_KEY = Object.fromEntries(ASSISTANTS.map((a) => [a.key, a]));
